/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Seat_Change_Intro_MinimumInputs */



/**
* | output |
* | --- |
* | "One of your empty {type} base seats gets a new type." |
*
* @param {Seat_Change_Intro_MinimumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_intro_minimum = /** @type {((inputs: Seat_Change_Intro_MinimumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Intro_MinimumInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Einer Ihrer freien ${i?.type}-Basisplätze erhält einen neuen Typ.`)
	return /** @type {LocalizedString} */ (`One of your empty ${i?.type} base seats gets a new type.`)
});